var _path, _g, _g2, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRegFullPageL(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 80,
    viewBox: "0 0 140 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 0.0195312H6.51163C2.91535 0.0195312 0 2.67266 0 5.94546V74.0936C0 77.3664 2.91535 80.0195 6.51163 80.0195H133.488C137.085 80.0195 140 77.3664 140 74.0936V5.94546C140 2.67266 137.085 0.0195312 133.488 0.0195312Z",
    fill: "#4F4C57"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_592_39402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.233 5.94531H45.3257V43.7231H133.233V5.94531Z",
    fill: "#625E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.527 39H62.4683C63.4755 39 64 38.5206 64 37.6046V32.3954C64 31.4794 63.4755 31 62.4683 31H54.527C53.5245 31 53 31.4751 53 32.3954V37.6046C53 38.5206 53.5245 39 54.527 39ZM56.6295 35.0792C55.9936 35.0792 55.4691 34.5998 55.4691 34.0133C55.4691 33.4313 55.9936 32.9433 56.6295 32.9433C57.2607 32.9433 57.7806 33.4313 57.7806 34.0133C57.7806 34.5998 57.2607 35.0792 56.6295 35.0792ZM54.6012 38.1482C54.1788 38.1482 53.9236 37.9128 53.9236 37.519V37.1765L55.2325 36.1236C55.4366 35.9567 55.6409 35.8754 55.859 35.8754C56.0818 35.8754 56.3139 35.9609 56.5181 36.1279L57.3954 36.8598L59.5907 35.0621C59.8134 34.878 60.0641 34.7924 60.324 34.7924C60.5747 34.7924 60.8393 34.8823 61.0528 35.0706L63.0717 36.7913V37.5233C63.0717 37.9128 62.8071 38.1482 62.3988 38.1482H54.6012Z",
    fill: "#908CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7444 14.834H53.4653C52.5662 14.834 51.8374 15.4973 51.8374 16.3155C51.8374 17.1337 52.5662 17.7969 53.4653 17.7969H69.7444C70.6434 17.7969 71.3723 17.1337 71.3723 16.3155C71.3723 15.4973 70.6434 14.834 69.7444 14.834Z",
    fill: "#908CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.093 20.7598H53.4653C52.5662 20.7598 51.8374 21.423 51.8374 22.2412C51.8374 23.0594 52.5662 23.7227 53.4653 23.7227H125.093C125.992 23.7227 126.721 23.0594 126.721 22.2412C126.721 21.423 125.992 20.7598 125.093 20.7598Z",
    fill: "#908CA0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_592_39402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.233 46.6855H45.3257V73.3522H133.233V46.6855Z",
    fill: "#625E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7444 55.5742H53.4653C52.5662 55.5742 51.8374 56.2375 51.8374 57.0557C51.8374 57.8739 52.5662 58.5372 53.4653 58.5372H69.7444C70.6434 58.5372 71.3723 57.8739 71.3723 57.0557C71.3723 56.2375 70.6434 55.5742 69.7444 55.5742Z",
    fill: "#908CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.093 61.5H53.4653C52.5662 61.5 51.8374 62.1633 51.8374 62.9815C51.8374 63.7997 52.5662 64.463 53.4653 64.463H125.093C125.992 64.463 126.721 63.7997 126.721 62.9815C126.721 62.1633 125.992 61.5 125.093 61.5Z",
    fill: "#908CA0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3257 5.94531H6.51172V74.0935H42.3257V5.94531Z",
    fill: "#908CA0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_592_39402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.907,
    height: 37.7778,
    fill: "white",
    transform: "translate(45.3257 5.94531)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_592_39402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.907,
    height: 26.6667,
    fill: "white",
    transform: "translate(45.3257 46.6855)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRegFullPageL);
export default __webpack_public_path__ + "static/media/icon-reg-full-page-L.7ec1f59905e6c035195ef0227a8d8846.svg";
export { ForwardRef as ReactComponent };